import { Component, OnDestroy } from '@angular/core';
import { ApiMode, ConfigService } from '@shared-library';
import { NGXLogger } from 'ngx-logger';
import { FastenService } from '../../services/fasten.service';

@Component({
    selector: 'settings-tab',
    templateUrl: './settings-tab.component.html',
    styleUrls: ['./settings-tab.component.css'],
    standalone: false
})
export class SettingsTabComponent implements OnDestroy {
  resetButtonState: 'idle' | 'loading' | 'success' | 'error' = 'idle';
  private resetButtonResetTimer?: ReturnType<typeof setTimeout>;

  constructor(
    public configService: ConfigService,
    private fastenService: FastenService,
    private logger: NGXLogger,
  ) { }

  ngOnDestroy(): void {
    if (this.resetButtonResetTimer) {
      clearTimeout(this.resetButtonResetTimer);
    }
  }

  onResetConnections() {
    if (this.resetButtonState === 'loading') {
      return;
    }

    this.setResetButtonState('loading');
    this.fastenService.revokeVaultProfileConnections().subscribe({
      next: () => {
        this.logger.info('Reset vault profile connections for test mode');
        this.setResetButtonState('success');
      },
      error: (error) => {
        this.logger.error('Failed to reset vault profile connections', error);
        this.setResetButtonState('error');
      }
    });
  }

  private setResetButtonState(state: 'idle' | 'loading' | 'success' | 'error') {
    if (this.resetButtonResetTimer) {
      clearTimeout(this.resetButtonResetTimer);
      this.resetButtonResetTimer = undefined;
    }

    this.resetButtonState = state;

    if (state === 'success' || state === 'error') {
      this.resetButtonResetTimer = setTimeout(() => {
        this.resetButtonState = 'idle';
      }, 1600);
    }
  }

  protected readonly ApiMode = ApiMode;
}
